import {
    Box, Button, Icon,
    Grow, Popper, Paper,
    MenuList, MenuItem,
    Divider, ClickAwayListener
} from '@mui/material'

import { useRef, useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'
import { createId } from '@services/utils'

import Styles from './style'

export const Submenu = (props) => {
    const navigate = useNavigate()

    const [open, setOpen] = useState(false)

    const anchorRef = useRef(null)
    const prevOpen = useRef(open)
    const mode = useRef('default')

    useEffect(() => {
        if (prevOpen.current === true && open === false)
            anchorRef.current.focus()
        prevOpen.current = open
    }, [open])

    const handleToggle = () => {
        if (props.disabled) return
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target))
            return
        setOpen(false)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpen(false)
        } else if (event.key === 'Escape')
            setOpen(false)
    }

    const handleNavigate = (event, path) => {
        handleClose(event)
        navigate(path)
    }

    return (
        <Box>
            <Button
                ref={anchorRef}
                onClick={handleToggle}
                variant={'header'}
                className={mode.current}
                disabled={props.disabled}
            >
                {props.label}
                <Icon>expand_{(open) ? 'less' : 'more' }</Icon>
            </Button>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement={'bottom-start'}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'}}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    autoFocusItem={open}
                                    onKeyDown={handleKeyDown}
                                    sx={Styles.menu}
                                >
                                    {props.items.map(submenu => {
                                        const key = createId()
                                        if (submenu.label === '-') return (<Divider key={key} />)
                                        else return (
                                            <MenuItem
                                                onClick={(event) => handleNavigate(event, submenu.path)}
                                                key={key}
                                                sx={Styles.menuItem}
                                                disabled={submenu.disabled}
                                            >
                                                {submenu.icon && (<Icon>{submenu.icon}</Icon>)} {submenu.label}
                                            </MenuItem>
                                        )
                                    })}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Box>
    )
}

export default Submenu